import React, { useState, Fragment } from "react";

const DDLcommon = (props) => {
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedKey, setSelectedKey] = useState("");

  const handleChange = (e) => {
    // alert(e.target.value + e.target.Text);
    // alert(JSON.stringify(e.target.options[e.target.selectedIndex].text));

    setSelectedValue(e.target.value);
    props.setSelectedValue(
      e.target.value,
      e.target.options[e.target.selectedIndex].text
    );
  };

  return (
    <Fragment>
      {/* <label htmlFor="colorDropdown">Select a color: </label> */}
      <select
        style={props.style}
        id={props.id}
        value={selectedValue}
        onChange={handleChange}
      >
        {props.showDefaultOption && (
          <option value={props.defaultValue}>{props.defaultLabel} </option>
        )}
        {props.sourceList.map((itme) => (
          <option key={itme.id} value={itme.id}>
            {itme.name}
          </option>
        ))}
      </select>
      {/* <p>Selected value: {selectedValue}</p> */}
    </Fragment>
  );
};

export default DDLcommon;
